var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1381 3.72623L13.9381 4.92623L10.8281 1.81523L12.0281 0.615234L15.1381 3.72623Z",
    fill: "#009FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.027 4.44141L13.227 5.6414L5.03398 13.8344L3.83398 12.6344L12.027 4.44141Z",
    fill: "#009FF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11797 11.9184L1.91797 10.7184L10.111 2.52539L11.311 3.72539L3.11797 11.9184Z",
    fill: "#009FF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.306641 15.4458L4.11864 14.3458L1.40664 11.6348L0.306641 15.4458Z",
    fill: "#009FF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.56f9475d58e613514f8712a7fe5c9398.svg";
export { ForwardRef as ReactComponent };